import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_guanyuwomen from '../views/lanhu_guanyuwomen/index.vue'
import lanhu_fuchizhengce from '../views/lanhu_fuchizhengce/index.vue'
import lanhu_zixunzhongxinxiangqing from '../views/lanhu_zixunzhongxinxiangqing/index.vue'
import lanhu_zixunzhongxin from '../views/lanhu_zixunzhongxin/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'
import lanhu_fuwushang from '../views/lanhu_fuwushang/index.vue'
import lanhu_login from '../views/lanhu_login/index.vue'
import { getToken } from '../utils/auth.js'

Vue.use(VueRouter)

const routes = [
    {
    path: '/',
    redirect: "/lanhu_shouye"
  },
  {
    path: '/lanhu_guanyuwomen',
    name: 'lanhu_guanyuwomen',
    component: lanhu_guanyuwomen
  },
  {
    path: '/lanhu_fuchizhengce',
    name: 'lanhu_fuchizhengce',
    component: lanhu_fuchizhengce
  },
  {
    path: '/lanhu_zixunzhongxinxiangqing',
    name: 'lanhu_zixunzhongxinxiangqing',
    component: lanhu_zixunzhongxinxiangqing
  },
  {
    path: '/lanhu_zixunzhongxin',
    name: 'lanhu_zixunzhongxin',
    component: lanhu_zixunzhongxin
  },
  {
    path: '/lanhu_shouye',
    name: 'lanhu_shouye',
    component: lanhu_shouye
  },
  {
    path: '/lanhu_fuwushang',
    name: 'lanhu_fuwushang',
    component: lanhu_fuwushang,
    meta: { title: '服务商' }
  },
  {
    path: '/web/login',
    name: 'lanhu_login',
    component: lanhu_login,
    meta: { hideHeader: true, title: '登录' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/lanhu_fuwushang' && !getToken()) {
    next({
      path: '/web/login',
      query: { redirect: to.fullPath }
    })
    return
  }
  next()
})

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title = `人工智能商城平台-${to.meta.title}`
  }
})

export default router
